import {
  Card,
  TextField,
  InlineGrid,
  Tag,
  InlineStack,
  BlockStack,
  Button,
  Layout,
  LegacyCard,
} from "@shopify/polaris";
import { useState, useCallback, useEffect } from "react";

import { create_update_app } from "../api";

export default function AppInput() {
  const [appName, setAppName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [sharedSecret, setSharedSecret] = useState("");
  const [shopName, setShopName] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const handleSetAppName = useCallback((value) => setAppName(value), []);
  const handleSetApiKey = useCallback((value) => setApiKey(value), []);
  const handleSetShopName = useCallback((value) => setShopName(value), []);
  const handleSetSharedSecret = useCallback(
    (value) => setSharedSecret(value),
    []
  );

  const CreateApp = async () => {
    try {
      setIsLoading(true);
      const params = {
        app_name: appName,
        api_key: apiKey,
        shared_secret: sharedSecret,
        shop_name: shopName,
      };
      const response = await create_update_app(params);
      if (response.status === 200) {
        handleSetApiKey("");
        handleSetSharedSecret("");
        handleSetShopName("");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <Layout.AnnotatedSection
        title="Installation information of the app"
        description="The custom app can only be installed in one store. Please fill in the app information and the corresponding store information here."
      >
        <LegacyCard sectioned>
          <BlockStack gap="100">
            <TextField
              value={appName}
              onChange={handleSetAppName}
              label="App Name"
            />
            <TextField
              value={shopName}
              onChange={handleSetShopName}
              label="Shop Name"
            />
            <TextField
              value={apiKey}
              onChange={handleSetApiKey}
              label="Api Key"
            />
            <TextField
              value={sharedSecret}
              onChange={handleSetSharedSecret}
              label="Shared Secret"
            />
            <InlineStack align="end">
              <Button
                submit
                disabled={!apiKey || !sharedSecret || isLoading}
                onClick={() => {
                  CreateApp();
                }}
                loading={isLoading}
              >
                Create
              </Button>
            </InlineStack>
          </BlockStack>
        </LegacyCard>
      </Layout.AnnotatedSection>
    </Layout>
  );
}
